import { PlacementKind, PlacementKind as K } from '@/webapi/use-experience-api';
import {
  LoadingStrategyOption,
  RecommendationType as T,
  RecStrategy,
} from '@/webapi/use-widget-catalog-api';

function moveAdvancedRulingToSecond(
  options?: LoadingStrategyOption[],
): LoadingStrategyOption[] | undefined {
  if (!options) return options;
  const [advanced, rest] = options.reduce(
    (acc, op) => {
      acc[op.value.type === T.ADVANCED_RULING ? 0 : 1].push(op);
      return acc;
    },
    [[], []],
  );

  rest.splice(1, 0, ...advanced);
  return rest;
}

export function filterRecommendations(
  placementKind: PlacementKind | undefined,
  recStrategies: RecStrategy,
  isSimilarProductsEnabled: boolean,
) {
  const options = recStrategies?.options?.filter((op) => {
    if ([K.HOMEPAGE, K.ALL_CATEGORIES].find(eqPlacement(placementKind))) {
      const strategies = [
        T.MANUAL,
        T.MOST_POPULAR,
        T.NEW_ARRIVALS,
        T.CART_ITEMS,
        T.PERSONALIZED,
        T.RECENTLY_VIEWED,
        T.PURCHASED_TOGETHER,
        T.VIEWD_TOGETHER,
        T.MOST_POPULAR,
        T.PERSONALIZED,
        T.ADVANCED_RULING,
        T.PAST_PURCHASES,
        T.VIEWED_WITH_RECENTLY_VIEWED,
        T.PURCHASED_WITH_RECENTLY_PURCHASED,
      ];
      if (isSimilarProductsEnabled) {
        strategies.push(T.SIMILAR_PRODUCTS);
      }
      return !!strategies.find(eqReq(op));
    }

    if ([K.ALL_PAGES, K.OTHER, K.MINI_CART].find(eqPlacement(placementKind))) {
      const strategies = [
        T.MANUAL,
        T.MOST_POPULAR,
        T.NEW_ARRIVALS,
        T.MOST_POPULAR,
        T.RECENTLY_VIEWED,
        T.CART_ITEMS,
        T.PERSONALIZED,
        T.ADVANCED_RULING,
        T.PAST_PURCHASES,
        T.VIEWED_WITH_RECENTLY_VIEWED,
        T.PURCHASED_WITH_RECENTLY_PURCHASED,
      ];
      if (isSimilarProductsEnabled) {
        strategies.push(T.SIMILAR_PRODUCTS);
      }
      return !!strategies.find(eqReq(op));
    }
    if (placementKind === K.ALL_PRODUCTS) {
      const strategies = [
        T.MANUAL,
        T.MOST_POPULAR,
        T.NEW_ARRIVALS,
        T.CART_ITEMS,
        T.VIEWD_TOGETHER,
        T.RECENTLY_VIEWED,
        T.PURCHASED_TOGETHER,
        T.PERSONALIZED,
        T.ADVANCED_RULING,
        T.PAST_PURCHASES,
        T.VIEWED_WITH_RECENTLY_VIEWED,
        T.PURCHASED_WITH_RECENTLY_PURCHASED,
      ];
      if (isSimilarProductsEnabled) {
        strategies.push(T.SIMILAR_PRODUCTS);
      }
      return !!strategies.find(eqReq(op));
    }
    if ([K.CART].find(eqPlacement(placementKind))) {
      const strategies = [
        T.MANUAL,
        T.RECENTLY_VIEWED,
        T.PURCHASED_TOGETHER,
        T.VIEWD_TOGETHER,
        T.MOST_POPULAR,
        T.PERSONALIZED,
        T.ADVANCED_RULING,
        T.PAST_PURCHASES,
        T.VIEWED_WITH_RECENTLY_VIEWED,
        T.PURCHASED_WITH_RECENTLY_PURCHASED,
      ];
      if (isSimilarProductsEnabled) {
        strategies.push(T.SIMILAR_PRODUCTS);
      }
      return !!strategies.find(eqReq(op));
    }

    if ([K.CHECKOUT].find(eqPlacement(placementKind))) {
      const strategies = [
        T.MANUAL,
        T.MOST_POPULAR,
        T.NEW_ARRIVALS,
        T.PERSONALIZED,
        T.RECENTLY_VIEWED,
        T.PURCHASED_TOGETHER,
        T.VIEWD_TOGETHER,
        T.ADVANCED_RULING,
        T.PAST_PURCHASES,
      ];
      if (isSimilarProductsEnabled) {
        strategies.push(T.SIMILAR_PRODUCTS);
      }
      return !!strategies.find(eqReq(op));
    }
    return false;
  });
  return { ...recStrategies, options: moveAdvancedRulingToSecond(options) };
}

function eqReq(op: LoadingStrategyOption) {
  return (x) => x === op.value.type;
}

function eqPlacement(placementKind: K) {
  return (x) => x === placementKind;
}
